import header from './header.js'
Vue.directive('header', header)




// WEBPACK FOOTER //
// ./src/js/directives/header/index.js